import { createSelector } from 'reselect';
import { MonitoringDashboardState } from '../types/store';

// Возвращает значение активного таба
export const dashboardTableSelector = createSelector(
  (state: { MonitoringDashboard: MonitoringDashboardState }) => state.MonitoringDashboard.selectedDashboard,
  (selectedDashboard) => selectedDashboard
);
